import React from "react";
import styled from "styled-components";
import { Flex } from "../shared/Flex";

const Wrapper = styled(Flex)`
  position: absolute;
  bottom: 0%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: auto;
  width: auto;
  // justify-content: center;
  // align-items: center;
  background-color: #000;
  padding: 10px 20px;
  border-radius: 9999px; /* Full rounded corners */
  box-sizing: border-box;
`;

const Message = styled.div`
  padding: 5px;
  font-size: 14px;
  color: #fff;
  text-align: center;
`;

const InfoAlert = ({ message }) => {
  if (!message) {
    return null;
  }

  return (
    <Wrapper>
      <Message>{message}</Message>
    </Wrapper>
  );
};
export default InfoAlert;
